import { Box, Typography } from '@material-ui/core'
import {useEffect} from 'react'

function NotFound(props: any) {
    useEffect(()=>{window.scrollTo(0,0);},[])
    return <Box p={3}>
        <Typography variant="h2">{props.title}</Typography>
    </Box>
}

export default NotFound
